import { pick } from '../../../../common-utilities/utils';
import { FINANCE_V2_HOSTNAME } from '../../../../common-utilities/utils/end-points';
import { FINANCE_REST_URLS } from '../../../../common-utilities/utils/end-points/finance-v2';
import { HTTP_METHODS } from '../../../utils/http-service';

export const CALCULATION_TYPE_OPTIONS = [
  { label: 'Fixed Amount', value: 'FIXED_AMOUNT' },
  { label: 'Percentage', value: 'PERCENTAGE' },
];

export const VALUE_MODE_OPTIONS = [
  { label: 'Configured Value', value: 'CONFIGURED_VALUE' },
  { label: 'Manual Entry', value: 'MANUAL_ENTRY' },
];

const FORM_FIELDS = [
  'id',
  'chargeCode',
  'chargeName',
  'hsnCode',
  'calculationType',
  'valueMode',
  'defaultValue',
  'taxable',
  'taxRate',
  'affectsPOTotal',
  'affectsBudget',
  'isActive',
  'description',
  'departments',
];

export const getDepartmentsLabel = (departmentIds, departmentList = []) => {
  if (!departmentIds?.length) return 'Not Configured';
  return departmentIds
    .map(
      (id) =>
        departmentList.find((dept) => String(dept.value) === String(id))
          ?.label || id
    )
    .join(', ');
};

export const getModalData = (data, setData) => {
  if (data) {
    const modalData = pick(data, FORM_FIELDS);
    setData(modalData);
  } else {
    setData({
      taxable: false,
      affectsPOTotal: true,
      affectsBudget: true,
      isActive: true,
    });
  }
};

export const modalActions = (data, type, setDataFunc) => {
  switch (type) {
    case 'EDIT':
      setDataFunc({
        type,
        data,
        title: 'Update Extra Charge',
      });
      break;

    case 'CREATE':
      setDataFunc({
        type,
        data: null,
        title: 'Create Extra Charge',
      });
      break;

    case 'DELETE':
      setDataFunc({
        type,
        data,
      });
      break;

    default:
      break;
  }
};

export const getCreateUpdateDetails = (data) => {
  const { id } = data;
  const method = id ? HTTP_METHODS.PUT : HTTP_METHODS.POST;
  const payload = pick(data, FORM_FIELDS.filter((field) => field !== 'id'));
  if (data?.valueMode !== 'CONFIGURED_VALUE') {
    delete payload.defaultValue;
  }
  if (!data?.taxable) {
    delete payload.taxRate;
  }
  const url = id
    ? `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.EXTRA_CHARGE}/${id}`
    : `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.EXTRA_CHARGE}`;
  const message = id
    ? 'Extra charge updated successfully'
    : 'Extra charge created successfully';

  return {
    method,
    payload,
    url,
    message,
  };
};
